export const AUTH_CONSTANTS = {
  ERROR_EMPTY_LOGIN_USER_DATA: '[ERROR] empty token.',
  // ERROR_LOGIN_NO_SERVER_ERROR_MESSAGE: 'เซิฟเวอร์ไม่ทำงาน โปรดกลับมาใช้ในภายหลัง',
  // ERROR_REGISTER_NO_SERVER_ERROR_MESSAGE: '[Error][RegisterAction] no server error message',
  // ERROR_EMPTY_REGISTER_USER_DATA: 'empty register user response data',
  // ERROR_INIT_REGISTER_DATA: '[ERROR] Input register data not completed',
  // ERROR_INPUT_REGISTER_DATA_INCOMPLETE: '[ERROR] ข้อมูลลงทะเบียนไม่ครบถ้วน',
  // ERROR_REGISTERED_USER_TRUCK_INFO: '[ERROR] การลงทะเบียนบุคคลผิดพลาด กรุณาเริ่มต้นใหม่',
};
